import {useParams} from 'react-router-dom';
import {DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES} from './index';

export function useLang() {
  const {lang} = useParams();
  return SUPPORTED_LANGUAGES.includes(lang) ? lang : DEFAULT_LANGUAGE;
}

// Prefixes an in-app path with the current language, e.g. withLang('en', '/faq/') -> '/en/faq/'.
// External (http/https) URLs are returned unchanged.
export function withLang(lang, path) {
  if (/^https?:\/\//.test(path)) {
    return path;
  }
  const clean = path.startsWith('/') ? path : `/${path}`;
  return `/${lang}${clean}`;
}

// Client-side fallback only: production redirects for '/' and un-prefixed legacy
// paths are expected to be handled at the edge by the CloudFront Function
// (see cloudfront-functions/language-redirect.js at the repo root).
export function detectBrowserLanguage() {
  const nav = typeof navigator !== 'undefined' ? navigator : null;
  const languages = (nav && nav.languages && nav.languages.length) ?
      nav.languages :
      [(nav && nav.language) || DEFAULT_LANGUAGE];
  for (const l of languages) {
    const code = String(l).slice(0, 2).toLowerCase();
    if (SUPPORTED_LANGUAGES.includes(code)) {
      return code;
    }
  }
  return DEFAULT_LANGUAGE;
}
